import { AllMembersComponent } from './Modules/All-Members/all-members.component';
import { AssetsViewComponent } from './Modules/assets/assets-view/assets-view.component';
import { CategoryComponent } from './Modules/setups/category/category.component';
import { SopComponent } from './Modules/setups/sop/sop.component';
import { SetupsComponent } from './Modules/setups/setups.component';
import { SocietyDetailsComponent } from './Modules/socity-rules/society-details/society-details.component';
import { SocityRulesComponent } from './Modules/socity-rules/socity-rules.component';
import { LibraryComponent } from './Modules/library/library.component';
import { MembersComponent } from './Modules/Members/members.component';
import { ProjectAssignComponent } from './Modules/assign/project-assign/project-assign.component';
import { UnitsComponent } from './Modules/master/units/units.component';
import { WingsComponent } from './Modules/master/wings/wings.component';
import { PhasesComponent } from './Modules/master/phases/phases.component';
import { ProjectsComponent } from './Modules/master/projects/projects.component';
import { NoticeDetailsComponent } from './Modules/notice-board/notice-details/notice-details.component';
import { NoticeBoardComponent } from './Modules/notice-board/notice-board.component';
import { EventDetailsComponent } from './Modules/event/event-details/event-details.component';
import { EventComponent } from './Modules/event/event.component';
import { AdminDashboardComponent } from './Dashboard/admin-dashboard/admin-dashboard.component';
import { AddEventComponent } from './Modules/event/add-event/add-event.component';
import { DocumentUploadComponent } from './Modules/DocumentManagement/document-upload/document-upload.component';
import { Routes } from '@angular/router';
import { DashboardComponent } from './Dashboard/dashboard/dashboard.component';
import { AuthGuard } from './Guard/auth.guard';
import * as pageNames from './common/pageNames';
import { LoginComponent } from './Login/login/login.component';
import { RaiseRequestsComponent } from './Dialogs/Dashboards/Requests/raise-requests/raise-requests.component';
import { EditRequestComponent } from './Dialogs/Dashboards/Requests/edit-request/edit-request.component';
import { AllRequestsComponent } from './Dialogs/Dashboards/Requests/raise-requests/all-requests/all-requests.component';
import { MyIssuesRequestsComponent } from './Dialogs/Dashboards/Requests/raise-requests/my-issues-requests/my-issues-requests.component';
import { AddMembersComponent } from './Modules/Members/add-members/add-members.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    title: pageNames.DASHBOARD,
  },
  { path: 'login', component: LoginComponent, title: pageNames.LOGIN },
  {
    path: 'access-denied',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./common/pages/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      ),
    title: 'Access Denied',
  },


  // Dashboard Requests
  { path: 'raise-requests', component: RaiseRequestsComponent, canActivate: [AuthGuard], },
  { path: 'edit-requests', component: EditRequestComponent, canActivate: [AuthGuard], },
  { path: 'all-requests', component: AllRequestsComponent, canActivate: [AuthGuard], },
  {
    path: 'request-dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Dialogs/Dashboards/Requests/request-dashboard/request-dashboard.component').then(
        (m) => m.RequestDashboardComponent
      ),
  },
  { path: 'my-requests', component: MyIssuesRequestsComponent, canActivate: [AuthGuard], },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], },

  //  {
  //   path: 'my-requests',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./Dialogs/Dashboards/Requests/raise-requests/all-requests/all-requests.component').then(
  //       (m) => m.AllRequestsComponent
  //     ),
  // },

  {
    path: 'add-members',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Members/add-members/add-members.component').then(
        (m) => m.AddMembersComponent
      ),
  },

  {
    path: 'add-documents',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/DocumentManagement/document-upload/document-upload.component').then(
        (m) => m.DocumentUploadComponent
      ),
  },
  {
    path: 'add-event',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/event/add-event/add-event.component').then(
        (m) => m.AddEventComponent
      ),
  },

  {
    path: 'event',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/event/event.component').then(
        (m) => m.EventComponent
      ),
  },


  {
    path: 'event-details/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/event/event-details/event-details.component').then(
        (m) => m.EventDetailsComponent
      ),
  },


  {
    path: 'admin-dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Dashboard/admin-dashboard/admin-dashboard.component').then(
        (m) => m.AdminDashboardComponent
      ),
  },

  {
    path: 'notice-board',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/notice-board/notice-board.component').then(
        (m) => m.NoticeBoardComponent
      ),
  },

  {
    path: 'notice-details/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/notice-board/notice-details/notice-details.component').then(
        (m) => m.NoticeDetailsComponent
      ),
  },

  //Master
  {
    path: 'projects',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/master/projects/projects.component').then(
        (m) => m.ProjectsComponent
      ),
  },
  {
    path: 'phases',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/master/phases/phases.component').then(
        (m) => m.PhasesComponent
      ),
  },
  {
    path: 'wings',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/master/wings/wings.component').then(
        (m) => m.WingsComponent
      ),
  },
  {
    path: 'floors',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/master/floors/floors.component').then(
        (m) => m.FloorsComponent
      ),
  },
  {
    path: 'units',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/master/units/units.component').then(
        (m) => m.UnitsComponent
      ),
  },

  //Assign
  {
    path: 'project-assign',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assign/project-assign/project-assign.component').then(
        (m) => m.ProjectAssignComponent
      ),
  },

  //Member
  {
    path: 'members',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Members/members.component').then(
        (m) => m.MembersComponent
      ),
  },

  {
    path: 'my-units',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/units/units.component').then(
        (m) => m.UnitsComponent
      ),
  },


  // All-Members

  // {
  //   path: 'management-committee',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./Modules/All-Members/management-committee/management-committee.component').then(
  //       (m) => m.ManagementCommitteeComponent
  //     ),
  // },

  {
    path: 'staff',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/staff/staff.component').then(
        (m) => m.StaffComponent
      ),
  },

  {
    path: 'staff/user-profile',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/user-profile/user-profile.component').then(
        (m) => m.UserProfileComponent),
  },
  {
    path: 'library',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/library/library.component').then(
        (m) => m.LibraryComponent
      ),
  },
  {
    path: 'meetings',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/meetings/meetings.component').then(
        (m) => m.MeetingsComponent
      ),
  },


  {
    path: 'society-rules',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/socity-rules/socity-rules.component').then(
        (m) => m.SocityRulesComponent
      ),
  },

  {
    path: 'buildings',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/buildings/buildings.component').then(
        (m) => m.BuildingsComponent
      ),
  },

  {
    path: 'society-details/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/socity-rules/society-details/society-details.component').then(
        (m) => m.SocietyDetailsComponent
      ),
  },

  {
    path: 'setups',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/setups.component').then(
        (m) => m.SetupsComponent
      ),
  },
  {
    path: 'sop',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/sop/sop.component').then(
        (m) => m.SopComponent
      ),
  },
  {
    path: 'category',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/category/category.component').then(
        (m) => m.CategoryComponent
      ),
  },
  {
    path: 'faq',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/faq-setup/faq-setup.component').then(
        (m) => m.FaqSetupComponent
      ),
  },
  {
    path: 'dos-donts',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/dos-donts-setup/dos-donts-setup.component').then(
        (m) => m.DosDontsSetupComponent
      ),
  },
  {
    path: 'terms-conditions',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/terms-conditions-setup/terms-conditions-setup.component').then(
        (m) => m.TermsConditionsSetupComponent
      ),
  },
  {
    path: 'user-manual',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/setups/user-manual-setup/user-manual-setup.component').then(
        (m) => m.UserManualSetupComponent
      ),
  },
  {
    path: 'assets-view',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/assets-view/assets-view.component').then(
        (m) => m.AssetsViewComponent
      ),
  },
  {
    path: 'asset-summary',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/asset-summary/asset-summary.component').then(
        (m) => m.AssetSummaryComponent
      ),
  },
  {
    path: 'asset-movement',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/asset-movement/asset-movement.component').then(
        (m) => m.AssetMovementComponent
      ),
  },
  {
    path: 'asset-movement-approval',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/asset-movement-approval/asset-movement-approval.component').then(
        (m) => m.AssetMovementApprovalComponent
      ),
  },
  {
    path: 'asset-dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/asset-dashboard/asset-dashboard.component').then(
        (m) => m.AssetDashboardComponent
      ),
  },
  {
    path: 'employee-setup',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/assets/employee-setup/employee-setup.component').then(
        (m) => m.EmployeeSetupComponent
      ),
  },
  {
    path: 'unit-catalog',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/unit-catalog/unit-catalog.component').then(
        (m) => m.UnitCatalogComponent
      ),
  },
  {
    path: 'all-members',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/all-members.component').then(
        (m) => m.AllMembersComponent
      ),
  },

  {
    path: 'society-members',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/society-members/society-members.component').then(
        (m) => m.SocietyMembersComponent
      ),
  },

  {
    path: 'staff',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/staff/staff.component').then(
        (m) => m.StaffComponent
      ),
  },

  {
    path: 'buildings',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/buildings/buildings.component').then(
        (m) => m.BuildingsComponent
      ),
  },

  {
    path: 'buildings/resident-user-profile',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/All-Members/resident-user-profile/resident-user-profile.component').then(
        (m) => m.ResidentUserProfileComponent
      ),
  },


  {
    path: 'service-booking',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/service-booking.component').then(
        (m) => m.ServiceBookingComponent
      ),
  },

  {
    path: 'ordered-specifications',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/ordered-specifications/ordered-specifications.component').then(
        (m) => m.OrderedSpecificationsComponent
      ),
  },
  {
    path: 'add-specifications',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/add-specificationsions/add-specificationsions.component').then(
        (m) => m.AddSpecificationsionsComponent
      ),
  },


  {
    path: 'ordered-service',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/ordered-service/ordered-service.component').then(
        (m) => m.OrderedServiceComponent
      ),
  },
  {
    path: 'add-service',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/add-service/add-service.component').then(
        (m) => m.AddServiceComponent
      ),
  },

  {
    path: 'checklist-dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/checklist-dashboard/checklist-dashboard.component').then(
        (m) => m.ChecklistDashboardComponent
      ),
  },
  // {
  //   path: 'checklist/create-checklist',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./Modules/checklist/create-checklist/create-checklist.component').then(
  //       (m) => m.CreateChecklistComponent
  //     ),
  // },

  {
    path: 'checklist/templates',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/checklist-templates/checklist-templates.component').then(
        (m) => m.ChecklistTemplatesComponent
      ),
  },

  {
    path: 'checklist/view-assigned-checklist',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/view-assigned-checklist/view-assigned-checklist.component').then(
        (m) => m.ViewAssignedChecklistComponent
      ),
  },

  {
    path: 'checklist/view-checklist-items',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/view-checklist-items/view-checklist-items.component').then(
        (m) => m.ViewChecklistItemsComponent
      ),
  },

  // Create checklist is opened as a dialog from checklist templates
  // {
  //   path: 'checklist/templates/create-checklist',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./Modules/checklist/create-checklist/create-checklist.component').then(
  //       (m) => m.CreateChecklistComponent
  //     ),
  // },

  // {
  //   path: 'checklist/checklist-categories',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./Modules/checklist/checklist-categories/checklist-categories.component').then(
  //       (m) => m.ChecklistCategoriesComponent
  //     ),
  // },

  {
    path: 'checklist/assigned-checklists',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/assigned-checklist/assigned-checklist.component').then(
        (m) => m.AssignedChecklistComponent
      ),
  },
  {
    path: 'checklist/self-checklist-history',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/self-checklist/self-checklist.component').then(
        (m) => m.SelfChecklistComponent
      ),
  },
  {
    path: 'checklist/self-checklist-history/self-checklist-items',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/self-checklist-items/self-checklist-items.component').then(
        (m) => m.SelfChecklistItemsComponent
      ),
  },

  {
    path: 'checklist/submitted-checklists',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/submitted-checklists/submitted-checklists.component').then(
        (m) => m.SubmittedChecklistsComponent
      ),
  },

  {
    path: 'checklist/flat-status-board',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/flat-status-board/flat-status-board.component').then(
        (m) => m.FlatStatusBoardComponent
      ),
  },

  {
    path: 'utility-management',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/utility-management/utility-management.component').then(
        (m) => m.UtilityManagementComponent
      ),
  },

  {
    path: 'checklist/checklist-setup',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/checklist-setup/checklist-setup.component').then(
        (m) => m.ChecklistSetupComponent
      ),
  },

  {
    path: 'checklist/user-checklist-items',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/checklist/user-checklist-items/user-checklist-items.component').then(
        (m) => m.UserChecklistItemsComponent
      ),
  },
  {
    path: 'category-unit-setup',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/service-booking/category-unit-setup/category-unit-setup.component').then(
        (m) => m.CategoryUnitSetupComponent
      ),
  },

  // Document Master
  {
    path: 'tds-document',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Document-master/DOCUMENT_MANAGEMENT/TDS_DOCUMENTS/tds-document.component').then(
        (m) => m.TDSDocumentComponent
      ),
  },
  {
    path: 'society-document',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Document-master/DOCUMENT_MANAGEMENT/SOCIETY_DOCUMENTS/society-document.component').then(
        (m) => m.SocietyDocumentComponent
      ),
  },
  {
    path: 'agreement-document',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Document-master/DOCUMENT_MANAGEMENT/AGREEMENT_DOCUMENTS/agreement-document.component').then(
        (m) => m.AgreementDocumentComponent
      ),
  },
  {
    path: 'home-loan-document',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/Document-master/DOCUMENT_MANAGEMENT/HOME_LOAN_DOCUMENTS/home-loan-document.component').then(
        (m) => m.HomeLoanDocumentComponent
      ),
  },
  {
    path: 'maintenance-management',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/MAINTAINANCE_MANAGEMENT/maintenance-managment/maintenance-managment.component').then(
        (m) => m.MaintenanceManagmentComponent
      ),
  },
  {
    path: 'appointment',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./Modules/appointment-module/appointment.module').then(
        (m) => m.AppointmentModule
      ),
  },
  {
    path: 'access-verification',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'verification-requests',
        pathMatch: 'full'
      },
      {
        path: 'verification-requests',
        loadComponent: () =>
          import('./Modules/access-verification/access-verification/access-verification.component').then(
            (m) => m.AccessVerificationComponent
          ),
      },
      {
        path: 'customer-signup-dashboard',
        loadComponent: () =>
          import('./Modules/access-verification/customer-signup-dashboard/customer-signup-dashboard.component').then(
            (m) => m.CustomerSignupDashboardComponent
          ),
      },
      {
        path: 'assign-projects',
        loadComponent: () =>
          import('./Modules/access-verification/assign-projects/assign-projects.component').then(
            (m) => m.AssignProjectsComponent
          ),
      },
    ],
  },
  {
    path: 'dues',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'due-types',
        pathMatch: 'full'
      },
      {
        path: 'due-types',
        loadComponent: () =>
          import('./Modules/dues/due-types/due-types.component').then(
            (m) => m.DueTypesComponent
          ),
      },
      {
        path: 'society-dues',
        loadComponent: () =>
          import('./Modules/dues/society-dues/society-dues.component').then(
            (m) => m.SocietyDuesComponent
          ),
      },
      {
        path: 'due-entries',
        loadComponent: () =>
          import('./Modules/dues/due-entries/due-entries.component').then(
            (m) => m.DueEntriesComponent
          ),
      },
      {
        path: 'bank-details',
        loadComponent: () =>
          import('./Modules/dues/bank-details/bank-details.component').then(
            (m) => m.BankDetailsComponent
          ),
      },
      {
        path: 'payment-history',
        loadComponent: () =>
          import('././Modules/dues/payment-history/payment-history.component').then(
            (m) => m.PaymentHistoryComponent
          ),
      },
      {
        path: 'vendor-payment-setup',
        loadComponent: () =>
          import('./Modules/dues/vendor-payment-setup/vendor-payment-setup.component').then(
            (m) => m.VendorPaymentSetupComponent
          ),
      },
    ],
  },
  {
    path: 'vendor-payment-setup',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/dues/vendor-payment-setup/vendor-payment-setup.component').then(
        (m) => m.VendorPaymentSetupComponent
      ),
  },
  {
    path: 'bank-details',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/dues/bank-details/bank-details.component').then(
        (m) => m.BankDetailsComponent
      ),
  },
  {
    path: 'bank-list',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./Modules/dues/bank-details/bank-details.component').then(
        (m) => m.BankDetailsComponent
      ),
  },
  {
    path: 'reminders',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'reminder-types',
        pathMatch: 'full'
      },
      {
        path: 'reminder-types',
        loadComponent: () =>
          import('./Modules/reminders/reminder-types/reminder-types.component').then(
            (m) => m.ReminderTypesComponent
          ),
      },
      {
        path: 'reminder-entries',
        loadComponent: () =>
          import('./Modules/reminders/reminder-entries/reminder-entries.component').then(
            (m) => m.ReminderEntriesComponent
          ),
      },
    ],
  },
];

